import moment from 'moment';
import _ from 'lodash';

import * as types from './types';
import {
  TransactionDetailsEnum,
  FifoEnum,
  BidPriceEnum,
} from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

const INITIAL_STATE = {
  altItems: [],
  onHandItems: [],
  bidPriceData: [],
  fifoItemsData: [],
  transactionDetailsData: [],
  fetchingBid: false,
  fetchingFifo: false,
  fetchingOnHands: false,
  submitting: false,
  submitted: false,
  submitError: null,
  fetchingTransaction: false,
  fetchFifoItemsError: null,
  fetchingBidError: null,
  fetchingOnHandsError: null,
  fetchingTransactionError: null,
  fetchingAltItemsError: null,
  report: null,

  printLoading: false,
  printError: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.ITEM_MAINTENANCE_LOADING:
      return {
        ...state,
        fetching: action.payload,
      };

    case types.ALTERNATIVE_ITEMS:
      const altItems = action.payload.data.Data;
      return {
        ...state,
        altItems,
      };

    case types.ON_HAND_ITEMS:
      const onHandItems = action.payload.data.Data;
      return {
        ...state,
        onHandItems: onHandItems.map(item => ({
          ...item,
          [BidPriceEnum.Value]: Number(item[BidPriceEnum.Value]).toFixed(4),
        })),
      };

    case types.BID_PRICE_DATA:
      const bidPriceData = action.payload.data.Data;

      return {
        ...state,
        bidPriceData: bidPriceData.map(bidPriceItem => ({
          ...bidPriceItem,
          [BidPriceEnum.BeginDT]: moment(
            bidPriceItem[BidPriceEnum.BeginDT]
          ).format(DATE_FORMAT_FOR_UI),
          [BidPriceEnum.EndDT]: moment(bidPriceItem[BidPriceEnum.EndDT]).format(
            DATE_FORMAT_FOR_UI
          ),
        })),
      };

    case types.FIFO_ITEMS:
      const fifoItemsData = action.payload.data.Data;
      return {
        ...state,
        fifoItemsData: fifoItemsData.map(fifoItems => ({
          ...fifoItems,
          [FifoEnum.ReceiptDT]: moment(fifoItems[FifoEnum.ReceiptDT]).format(
            DATE_FORMAT_FOR_UI
          ),
          [FifoEnum.Price]: Number(fifoItems[FifoEnum.Price]).toFixed(4),
          [FifoEnum.Value]: Number(fifoItems[FifoEnum.Value]).toFixed(4),
        })),
      };

    case types.BID_PRICE_LOADING:
      return {
        ...state,
        fetchingBid: action.payload,
      };

    case types.FIFO_LOADING:
      return {
        ...state,
        fetchingFifo: action.payload,
      };

    case types.SUBMITTING_ITEM_DETAIL:
      return {
        ...state,
        submitting: action.payload,
      };

    case types.ITEM_DETAIL_SUBMIT:
      return {
        ...state,
        submitted: true,
      };

    case types.SUBMIT_ITEM_DETAIL_ERROR:
      const submitErrorResponse = action.payload.response;
      if (
        _.has(submitErrorResponse, 'data.Errors') &&
        submitErrorResponse.data.Errors.length
      ) {
        return {
          ...state,
          submitError: submitErrorResponse.data.Errors,
        };
      }
      return {
        ...state,
        submitError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while saving Item Detail. Please try again',
        },
      };

    case types.ON_HAND_ITEMS_LOADING:
      return {
        ...state,
        fetchingOnHands: action.payload,
      };

    case types.CLEAR_ITEM_ERROR:
      return {
        ...state,
        submitted: false,
        submitError: null,
        fetchFifoItemsError: null,
        fetchingBidError: null,
        fetchingOnHandsError: null,
        fetchingTransactionError: null,
        fetchingAltItemsError: null,
        printError: null,
      };

    case types.TRANSACTION_DETAILS_DATA:
      const transactionDetailsData = action.payload.data.Data;

      return {
        ...state,
        transactionDetailsData: transactionDetailsData.map(
          transactionDetailsItem => ({
            ...transactionDetailsItem,
            [TransactionDetailsEnum.TransactionDT]: moment(
              transactionDetailsItem[TransactionDetailsEnum.TransactionDT]
            ).format(DATE_FORMAT_FOR_UI),
            [TransactionDetailsEnum.PrimaryPrice]: Number(
              transactionDetailsItem[TransactionDetailsEnum.PrimaryPrice]
            ).toFixed(4),
            [TransactionDetailsEnum.SecondaryPrice]: Number(
              transactionDetailsItem[TransactionDetailsEnum.SecondaryPrice]
            ).toFixed(4),
          })
        ),
      };

    case types.TRANSACTION_DETAILS_LOADING:
      return {
        ...state,
        fetchingTransaction: action.payload,
      };

    case types.FETCH_BID_PRICE_ERROR:
      const fetchingBidErrorResponse = action.payload.response;
      if (
        _.has(fetchingBidErrorResponse, 'data.Errors') &&
        fetchingBidErrorResponse.data.Errors.length
      ) {
        return {
          ...state,
          fetchingBidError: fetchingBidErrorResponse.data.Errors,
        };
      }

      return {
        ...state,
        fetchingBidError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while retrieving Bid Price List Information. Please try again',
        },
      };

    case types.FETCH_ON_HANDS_ERROR:
      const fetchingOnHandsErrorResponse = action.payload.response;
      if (
        _.has(fetchingOnHandsErrorResponse, 'data.Errors') &&
        fetchingOnHandsErrorResponse.data.Errors.length
      ) {
        return {
          ...state,
          fetchingOnHandsError: fetchingOnHandsErrorResponse.data.Errors,
        };
      }

      return {
        ...state,
        fetchingOnHandsError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while retrieving On Hands Items. Please try again',
        },
      };

    case types.FETCH_TRANSACTION_ERROR:
      const fetchingTransactionErrorResponse = action.payload.response;
      if (
        _.has(fetchingTransactionErrorResponse, 'data.Errors') &&
        fetchingTransactionErrorResponse.data.Errors.length
      ) {
        return {
          ...state,
          fetchingTransactionError:
            fetchingTransactionErrorResponse.data.Errors,
        };
      }

      return {
        ...state,
        fetchingTransactionError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while retrieving Transaction detail. Please try again',
        },
      };

    case types.ALTERNATIVE_ITEMS_ERROR:
      const fetchingAltItemsErrorResponse = action.payload.response;

      if (
        _.has(fetchingAltItemsErrorResponse, 'data.Errors') &&
        fetchingAltItemsErrorResponse.data.Errors.length
      ) {
        return {
          ...state,
          fetchingAltItemsError: fetchingAltItemsErrorResponse.data.Errors,
        };
      }

      return {
        ...state,
        fetchingAltItemsError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while retrieving alternative items. Please try again',
        },
      };

    case types.FETCH_FIFO_ITEMS_ERROR:
      const fetchFifoItemsErrorResponse = action.payload.response;

      if (
        _.has(fetchFifoItemsErrorResponse, 'data.Errors') &&
        fetchFifoItemsErrorResponse.data.Errors.length
      ) {
        return {
          ...state,
          fetchFifoItemsError: fetchFifoItemsErrorResponse.data.Errors,
        };
      }

      return {
        ...state,
        fetchFifoItemsError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while retrieving FIFO Items. Please try again',
        },
      };

    case types.PRINT_REPORT_ERROR:
      const printError = action.payload.response;

      if (_.has(printError, 'data.Errors') && printError.data.Errors.length) {
        return {
          ...state,
          printError: printError.data.Errors,
        };
      }

      return {
        ...state,
        printError: {
          Title: TitleEnum.Error,
          Message: 'An error occurred while printing FIFO. Please try again',
        },
      };

    case types.PRINT_REPORT_LOADING:
      return {
        ...state,
        printLoading: action.payload,
      };

    case types.GET_REPORT:
      return { ...state, report: action.payload };

    case types.CLEAR_REPORT:
      return { ...state, report: null };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/state/addEditItem/reducer.js